import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-lugarentrega',
  templateUrl: './lugarentrega.component.html',
  styleUrls: ['./lugarentrega.component.scss']
})
export class LugarentregaComponent {

  constructor(public dialogRef: MatDialogRef<LugarentregaComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    console.log(data);
  }

  exit(response:string){
    this.dialogRef.close(response);
  }

}
